import React, {useState, useEffect} from "react";
import Tabs from "../atoms/Tabs";
import Part3dTab from "./Part3dTab";
import Part2dTab from "./Part2dTab";
import PartDetailTab from "./PartDetailTab";
import NotesTab from "./NotesTab";
import ColorTab from "./ColorTab";

const PartSelector = ({
                        partArray,
                        code,
                        codeKeyData,
                        stepObject,
                        selectedIndex,
                        personalItemObject,
                        fetchedPartGroups,
                        processedParts,
                        isLoading
                      }) => {
  const [currentTab, setCurrentTab] = useState("OPTION");
  const [initDetailIndex, setInitDetailIndex] = useState(0);
  const [colorByCategory, setColorByCategory] = useState(null);
  const [colorItemObject, setColorItemObject] = useState(null);

  useEffect(() => {
    if (selectedIndex !== undefined) {
      setInitDetailIndex(selectedIndex);
    }
  }, [selectedIndex]);

  return (
    <div className={"option-expand"}>
      <Tabs
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
        stepObject={stepObject}
        code={code}
        setColorByCategory={setColorByCategory}
        setColorItemObject={setColorItemObject}
        codeKeyData={codeKeyData}
      />

      {currentTab === "OPTION" && (stepObject.stepType === "PART_3D" || stepObject.stepType === "MATERIAL") && (
        <Part3dTab
          code={code}
          codeKeyData={codeKeyData}
          fetchedPartGroups={fetchedPartGroups}
          processedParts={processedParts}
          isLoading={isLoading}
        />
      )}


      {currentTab === "COLOR" && (
        <ColorTab
          code={code}
          colorByCategory={colorByCategory}
          codeKeyData={codeKeyData}
          colorItemObject={colorItemObject}
        />
      )}

      {currentTab === "OPTION" && stepObject.stepType === "PART_2D" && (
        <Part2dTab
          personalItemObject={personalItemObject}
          code={code}
          codeKeyData={codeKeyData}
        />
      )}

      {currentTab === "DETAIL" && (
        <PartDetailTab
          partArray={partArray}
          code={code}
          selectedIndex={initDetailIndex}
          personalItemObject={personalItemObject}
        />
      )}

      {currentTab === "NOTE" && (
        <NotesTab code={code}/>
      )}
    </div>
  );
}

export default PartSelector;
